import React from 'react';
import './Match.css';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function fmtDate(iso) {
  if (!iso) return 'TBD';
  const [, m, d] = iso.split('-').map(Number);
  return `${MONTHS[m - 1]} ${d}`;
}

function TeamSide({ team, side, winner, onSelectTeam }) {
  const clickable = !!team.id;
  const content = (
    <>
      {side === 'away' && (
        <img src={team.logo_url || '/team-placeholder.svg'} alt="" className="match-logo"
          onError={(e) => { e.target.src = '/team-placeholder.svg'; }} />
      )}
      <span className="match-team-name">{team.name}</span>
      {side === 'home' && (
        <img src={team.logo_url || '/team-placeholder.svg'} alt="" className="match-logo"
          onError={(e) => { e.target.src = '/team-placeholder.svg'; }} />
      )}
    </>
  );
  const cls = `match-team match-${side} ${winner ? 'match-winner' : ''} ${clickable ? 'clickable' : ''}`;
  if (clickable) {
    return <button className={cls} onClick={() => onSelectTeam({ id: team.id, name: team.name })}>{content}</button>;
  }
  return <span className={cls}>{content}</span>;
}

function Match({ match, onSelectTeam }) {
  const played = match.status === 'FT' && match.home_score != null;
  const homeWin = played && match.home_score > match.away_score;
  const awayWin = played && match.away_score > match.home_score;

  return (
    <div className="match">
      <span className="match-date">{fmtDate(match.date)}</span>
      <TeamSide team={match.home} side="home" winner={homeWin} onSelectTeam={onSelectTeam} />
      <span className={`match-score ${played ? '' : 'match-score-tbd'}`}>
        {played ? `${match.home_score}–${match.away_score}` : 'v'}
      </span>
      <TeamSide team={match.away} side="away" winner={awayWin} onSelectTeam={onSelectTeam} />
    </div>
  );
}

export default Match;
